// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"JY-z","sponsoredTooltipWrapper":"KY-z","sponsoredTooltip":"LY-z","newCard":"MY-z"};